/**
 * The catalog constants.
 */
export const Constants = {
    ProductGroup: {
        Root: "_ROOT",
        Catalog: "_CATALOGOUE"
    },
    Locale: {
        Default: "de-DE",
        Invariant: "und"
    },
    ValueFormat: {
        Unformatted: "UNFORMATTED",
        Formatted: "FORMATTED"
    },
    ContainerMappingType: {
        None: "NONE",
        Filtered: "FILTERED",
        Unfiltered: "UNFILTERED"
    },
    ParameterMappingType: {
        None: "NONE",
        Filtered: "FILTERED",
        Unfiltered: "UNFILTERED"
    },
    ValueMappingType: {
        All: "ALL",
        Selectable: "SELECTABLE",
        Selected: "SELECTED"
    },
    TranslationMappingType: {
        Translations: "TRANSLATIONS",
        TranslationContext: "TRANSLATION_CONTEXT"
    },
    MappingProfile: {
        Minimum: "MINIMUM_CONTENT_MAPPING",
        Medium: "MEDIUM_CONTENT_MAPPING",
        Maximum: "MAXIMUM_CONTENT_MAPPING"
    },
    DefaultUI: "default",
    InternalUI: "internal"
} as const
